import { UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { useCreateMutation } from '../../../../../../lib/utils/createMutation';
import { showErrorMessages } from '../../util/util';
import { ReviewCreateErrorResponseType } from '../../types/ReviewCreateErrorResponseType';
import { ReviewUpdateResponseDto } from '../../types/ReviewUpdateType';
import { ReviewUpdateRequestBodyDto } from '../../../../../../types/api/reviews';
import ReviewApiV2 from '../../../../../../lib/api/cs/review/ReviewApiV2';
import { REVIEW } from '../../../../../../constants/queryKeys';

export type ReviewUpdateRequestPayloadType = {
  data: ReviewUpdateRequestBodyDto;
  id: number;
};

const useUpdateReviewQuery = (): UseMutationResult<
  ReviewUpdateResponseDto,
  unknown,
  ReviewUpdateRequestPayloadType,
  unknown
> => {
  const navigate = useNavigate();
  return useCreateMutation<ReviewUpdateRequestPayloadType, ReviewUpdateResponseDto>({
    queryKey: REVIEW.UPDATE,
    apiFunction: (payload: ReviewUpdateRequestPayloadType) => ReviewApiV2.updateReviewDetails(payload),
    onSuccess: () => {
      navigate('/cs/review/list');
    },
    onError: (error: AxiosError) => {
      const data = error?.response?.data as { errors?: ReviewCreateErrorResponseType[] };
      showErrorMessages(data.errors || []);
    },
  });
};

export default useUpdateReviewQuery;
